import { Status, statusLabelMapper } from '../constants';

export const convertActiveStatus = {
  toStr: (value: string | boolean | null | undefined): Status | '' => {
    if (value === true || value === 'true' || value === Status.active)
      return Status.active;
    if (value === false || value === 'false' || value === Status.disabled)
      return Status.disabled;
    return '';
  },
  toBoolean: (value: string | boolean | null | undefined): boolean => {
    if (value === true || value === 'true' || value === Status.active)
      return true;
    return false;
  },
  toLabel: (value: string | boolean | null | undefined): string => {
    if (value === true || value === 'true' || value === Status.active)
      return statusLabelMapper[Status.active];
    if (value === false || value === 'false' || value === Status.disabled)
      return statusLabelMapper[Status.disabled];
    return '';
  }
};
